// src/lib/pool-prenoms.js — LES PRÉNOMS DU POOL (lot Dimitri 2026-08-19).
//
// Le pool de l'orchestrateur ne transporte que des emails : ce client va
// chercher les prénoms SAISIS (Paramètres → Comptes) via `pool_prenoms`
// (cloisonné serveur : son pool + lui ; admin = liste d'emails demandée).
// ⚠️ TOUJOURS UN FILET LOCAL derrière (libelleDepuisEmail) : ce module rend
// {} sur toute erreur — un prénom manquant ne casse jamais un écran, et
// l'email brut ne s'affiche jamais.

import { supabase } from '../supabase'

const TTL_MS = 5 * 60_000
let cachePrenoms = null // { ts, prenoms }

export async function fetchPoolPrenoms({ emails } = {}) {
  if (cachePrenoms && Date.now() - cachePrenoms.ts < TTL_MS && !emails) {
    return cachePrenoms.prenoms
  }
  try {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.access_token) return {}
    const res = await fetch('/api/beds24-mapping', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ action: 'pool_prenoms', ...(emails ? { emails } : {}) }),
    })
    if (!res.ok) return {}
    const json = await res.json().catch(() => ({}))
    const prenoms = json?.prenoms && typeof json.prenoms === 'object' ? json.prenoms : {}
    if (!emails) cachePrenoms = { ts: Date.now(), prenoms }
    return prenoms
  } catch (e) {
    console.error('[pool-prenoms]', e?.message || e)
    return {}
  }
}

export function _viderCachePrenoms() { cachePrenoms = null }
